import React, { forwardRef, ComponentProps } from 'react';

import Icon, { IconWithRender } from './Icon';

const ViewTransparentIcon = forwardRef<
  SVGSVGElement,
  ComponentProps<typeof Icon>
>((props, ref) => (
  <Icon data-testid="viewTransparent" ref={ref} {...props}>
    <path d="M18.84,6.51h-.3V6.05A3.76,3.76,0,0,0,14.79,2.3H5A3.76,3.76,0,0,0,1.25,6.05v7.69A3.76,3.76,0,0,0,5,17.49h.46v.3A3.92,3.92,0,0,0,9.37,21.7h9.47a3.92,3.92,0,0,0,3.91-3.91V10.42A3.92,3.92,0,0,0,18.84,6.51ZM5,16a2.25,2.25,0,0,1-2.25-2.25V6.05A2.25,2.25,0,0,1,5,3.8h9.79A2.25,2.25,0,0,1,17,6.05v.46h-.52a.75.75,0,0,0,0,1.5H17v5.73A2.25,2.25,0,0,1,14.79,16Zm16.25,1.8a2.41,2.41,0,0,1-2.41,2.41H9.37A2.41,2.41,0,0,1,7,17.79v-.3h7.83a3.76,3.76,0,0,0,3.75-3.75V8h.3a2.41,2.41,0,0,1,2.41,2.41ZM13.68,8H12.42a.75.75,0,0,1,0-1.5h1.26a.75.75,0,0,1,0,1.5ZM9.58,8H8.31a.75.75,0,1,1,0-1.5H9.58a.75.75,0,0,1,0,1.5ZM6.21,15.27a.75.75,0,0,1-.75-.75V13.26a.75.75,0,0,1,1.5,0v1.26A.75.75,0,0,1,6.21,15.27Zm0-4.1a.76.76,0,0,1-.75-.75V9.15a.75.75,0,0,1,1.5,0v1.27A.76.76,0,0,1,6.21,11.17Z" />
  </Icon>
)) as IconWithRender;

ViewTransparentIcon.displayName = 'ViewTransparentIcon';
ViewTransparentIcon.renderIcon = (props) => <ViewTransparentIcon {...props} />;
export default ViewTransparentIcon;
